import { observer } from "mobx-react";
import { useState } from "react";

interface IOderStatusDdl {
  orderId: number;
  currentStatus: string;
  paymentStatusId: number;
  statusList: { text: string; value: number }[];
  handleStatusChange: (
    id: number,
    status: number,
    paymentStatusId: number
  ) => void;
}

const OderStatusDdl = observer(
  ({
    orderId,
    currentStatus,
    paymentStatusId,
    statusList,
    handleStatusChange,
  }: IOderStatusDdl) => {
    const [isStatusDropdownOpen, setStatusDropdownOpen] = useState(false);

    return (
      <span
        className="dropdown ms-2"
        onClick={() => setStatusDropdownOpen(!isStatusDropdownOpen)}
      >
        <button
          className={`btn btn-default dropdown-toggle ${
            isStatusDropdownOpen ? "show" : ""
          }`}
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {currentStatus}
        </button>
        <ul className={`dropdown-menu ${isStatusDropdownOpen ? "show" : ""}`}>
          {statusList.map((p, i) => (
            <li key={"sts_" + i}>
              <button
                className="dropdown-item"
                type="button"
                onClick={() =>
                  currentStatus != p.text &&
                  handleStatusChange(orderId, p.value, paymentStatusId)
                }
              >
                {p.text}
              </button>
            </li>
          ))}
        </ul>
      </span>
    );
  }
);

export default OderStatusDdl;
